var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98594 4C3.62538 4 4.14375 4.51837 4.14375 5.15781V24.4844H28.8141C29.4535 24.4844 29.9719 25.0027 29.9719 25.6422C29.9719 26.2816 29.4535 26.8 28.8141 26.8H2.98594C2.3465 26.8 1.82812 26.2816 1.82812 25.6422V5.15781C1.82812 4.51837 2.3465 4 2.98594 4Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0557 7.79413C25.5672 8.1778 25.6709 8.90351 25.2873 9.41507L19.2755 17.4307C19.0569 17.7222 18.7137 17.8938 18.3493 17.8938C17.9849 17.8938 17.6417 17.7222 17.423 17.4307L15.0094 14.2126L9.25601 21.8838C8.87234 22.3954 8.14662 22.499 7.63507 22.1154C7.12351 21.7317 7.01984 21.006 7.40351 20.4944L14.0832 11.5882C14.3019 11.2966 14.645 11.1251 15.0094 11.1251C15.3739 11.1251 15.717 11.2966 15.9357 11.5882L18.3493 14.8063L23.4348 8.02569C23.8184 7.51414 24.5441 7.41047 25.0557 7.79413Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartsIcon);
export default __webpack_public_path__ + "static/media/charts-icon.a0e439abd83f09dec04b0b316368852a.svg";
export { ForwardRef as ReactComponent };